import React, { FC } from 'react'
import classNames from 'classnames'
import styles from './TopSpacer.module.scss'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'

interface Props {
  isRootOrChild: boolean
  isRootClubChannel: boolean
}

export const TopSpacer: FC<Props> = ({ isRootClubChannel, isRootOrChild }) => (
  <>
    {/* Web */}
    <ConditionalRender mobileApp={false}>
      <div
        className={classNames({
          [styles.TopPadding]: !isRootOrChild,
          [styles.TopPaddingThemed]: isRootOrChild,
          [styles.TopPaddingThemedMobile]: isRootOrChild,
          [styles.TopPaddingThemedMobileWithoutMenuLinks]: isRootClubChannel
        })}
      />
    </ConditionalRender>
    {/* Mobile */}
    <ConditionalRender web={false}>
      <div
        className={classNames({
          [styles.TopPadding]: !isRootOrChild,
          [styles.TopPaddingThemedMobileWithoutMenuLinks]: isRootOrChild
        })}
      />
    </ConditionalRender>
  </>
)
